import { H3, List } from '@ahmdigital/ui';
import { map } from 'lodash/fp';

import DownloadLink from '../download-link';
import styles from '../../styles.module.sass';

type ProductSubsectionProps = {
  data: {}[];
  link: string;
  title: string;
};

const ProductSubsection = ({ data, link, title }: ProductSubsectionProps) => (
  <div id={link} className={styles.infoBlock}>
    <H3>{title}</H3>
    <List variant={styles.list}>
      {map(
        // @ts-expect-error - Automatic, Please fix when editing this file
        ({ guideUrl, name }) => (
          <DownloadLink key={name} url={guideUrl} name={name} />
        ),
        data,
      )}
    </List>
  </div>
);

export default ProductSubsection;
